import React from "react";
import PackageJson from "../../../package.json";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  const { version } = PackageJson;
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}>{version} © SASMITHA</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Astara Media Natapraja
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
